/// <reference path="../../TypeLite.Net4.d.ts" />

//export type ApiResponse = Record<string, any>

export enum OverviewPageActionTypes {
    FETCH_REQUEST_GroupeServiceItems = '@@overviewPage/FETCH_REQUEST',
    FETCH_SUCCESS_GroupeServiceItems = '@@overviewPage/FETCH_SUCCESS',
    PUSH_REQUEST_GroupedServiceItems = '@@overviewPage/PUSH_REQUEST',
    FETCH_REQUEST_VinCheckResult = '@@overviewPage/FETCH_REQUEST_VIN_RESULT',
    FETCH_SUCCESS_VinCheckResult = '@@overviewPage/FETCH_SUCCESS_VIN_RESULT',
    FETCH_FAILURE_VinCheckResult = '@@overviewPage/FETCH_FAILURE_VIN_RESULT'
}

// Declare state types with `readonly` modifier to get compile time immutability.
export interface OverviewPageState {
    readonly loading: boolean
    readonly data: SkodaAuto.Marvin.ServiceAvailability.Web.App.Models.Data.ServiceGroupModel[]
    readonly errors?: string
}
